import { ROLE_ENUM_VALUES } from '../../api_enums/ROLE_ENUM';

export function RoleElement(props: { value: string }) {
  const role = Array.from(ROLE_ENUM_VALUES).filter(
    (r) => r[0] === props.value,
  )[0];
  return <span key={role[0]}>{role[1].label}</span>;
}
